var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapTitleImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 666,
    height: 503,
    viewBox: "0 0 666 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1102_2269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.298 150.088L99.4242 120.237H53.2292L45.3551 150.088H0L49.4496 0H105.304L154.753 150.088H107.298ZM75.9068 34.6356L61.3133 89.1373H91.3401L76.7467 34.6356H75.9068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.358 151.752C236.889 151.752 229.61 149.88 223.521 146.135C217.501 142.322 213.127 137.017 210.397 130.222H209.557V150.088H166.512V0H209.557V55.9579H210.397C213.127 48.8851 217.466 43.4072 223.416 39.5241C229.435 35.5717 236.574 33.5955 244.833 33.5955C259.462 33.5955 270.696 38.692 278.535 48.8851C286.374 59.0782 290.293 73.6744 290.293 92.6737C290.293 111.604 286.409 126.2 278.64 136.462C270.871 146.655 259.777 151.752 245.358 151.752ZM241.159 73.6397C237.869 68.8552 233.425 66.463 227.825 66.463C222.226 66.463 217.746 68.8552 214.387 73.6397C211.097 78.3549 209.417 84.7342 209.347 92.7777C209.417 100.891 211.097 107.27 214.387 111.916C217.676 116.562 222.156 118.884 227.825 118.884C233.425 118.884 237.869 116.527 241.159 111.812C244.518 107.097 246.198 100.717 246.198 92.6737C246.198 84.6995 244.518 78.3549 241.159 73.6397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.476 153C342.438 153 327.529 147.765 316.751 137.294C305.972 126.755 300.582 111.846 300.582 92.5697C300.582 73.7784 306.042 59.0435 316.961 48.3651C327.949 37.6866 342.788 32.3474 361.476 32.3474C380.304 32.3474 395.177 37.6866 406.096 48.3651C417.015 58.9742 422.474 73.709 422.474 92.5697C422.474 111.846 417.085 126.755 406.306 137.294C395.527 147.765 380.584 153 361.476 153ZM361.476 122.525C366.865 122.525 371.1 119.925 374.179 114.724C377.259 109.523 378.799 102.173 378.799 92.6737C378.799 83.3821 377.224 76.1013 374.074 70.8314C370.995 65.4922 366.795 62.8226 361.476 62.8226C356.156 62.8226 351.957 65.4922 348.877 70.8314C345.797 76.1013 344.258 83.3821 344.258 92.6737C344.258 102.243 345.762 109.627 348.772 114.828C351.782 119.959 356.016 122.525 361.476 122.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.025 35.2597V150.088H512.029V127.517H511.189C508.81 135.492 504.855 141.628 499.326 145.927C493.866 150.226 486.902 152.376 478.433 152.376C465.694 152.376 455.301 148.493 447.251 140.727C439.272 132.891 435.283 122.282 435.283 108.899V35.2597H478.328V99.3304C478.328 105.294 479.833 109.905 482.843 113.164C485.852 116.354 489.912 117.948 495.021 117.948C499.851 117.948 503.7 116.249 506.57 112.852C509.51 109.454 510.979 104.982 510.979 99.4344V35.2597H554.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.587 10.0891H623.632V35.2597H644V66.1509H623.632V108.587C623.632 115.868 627.972 119.508 636.651 119.508C639.451 119.508 641.9 119.335 644 118.988V148.528C638.891 149.568 632.976 150.088 626.257 150.088C609.949 150.088 598.26 147.591 591.191 142.599C584.122 137.606 580.587 129.424 580.587 118.052V66.1509H565.259V35.2597H580.587V10.0891Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1102_2269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.73 226.3V474.7H164.64V425.875H162.838C157.733 443.125 149.249 456.4 137.387 465.7C125.676 475 110.736 479.65 92.5676 479.65C65.2402 479.65 42.9429 471.25 25.6757 454.45C8.55856 437.5 0 414.55 0 385.6V226.3H92.3423V364.9C92.3423 377.8 95.5706 387.775 102.027 394.825C108.483 401.725 117.192 405.175 128.153 405.175C138.514 405.175 146.772 401.5 152.928 394.15C159.234 386.8 162.387 377.125 162.387 365.125V226.3H254.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.135 303.475C285.135 277.525 295.495 257.125 316.216 242.275C336.937 227.425 365.39 220 401.577 220C437.913 220 466.291 227.65 486.712 242.95C507.282 258.25 517.568 279.475 517.568 306.625H433.784C433.784 298.525 430.781 292.15 424.775 287.5C418.919 282.7 410.961 280.3 400.901 280.3C392.643 280.3 385.961 281.875 380.856 285.025C375.901 288.025 373.423 292.15 373.423 297.4C373.423 305.2 381.456 310.6 397.523 313.6L453.604 324.625C478.228 329.425 496.246 337.375 507.658 348.475C519.219 359.425 525 374.35 525 393.25C525 420.1 513.889 441.475 491.667 457.375C469.595 473.125 440.24 481 403.604 481C365.315 481 335.435 473.275 313.964 457.825C292.643 442.225 281.156 421 279.504 394.15H368.694C369.595 402.4 373.198 408.925 379.504 413.725C385.961 418.375 394.369 420.7 404.73 420.7C413.739 420.7 420.796 419.275 425.901 416.425C431.006 413.425 433.559 409.375 433.559 404.275C433.559 400.375 431.757 397.225 428.153 394.825C424.55 392.275 418.544 390.25 410.135 388.75L362.162 379.3C337.087 374.35 317.943 365.425 304.73 352.525C291.667 339.475 285.135 323.125 285.135 303.475Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1102_2269",
    x: 0,
    y: 0,
    width: 666,
    height: 175,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1102_2269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1102_2269",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1102_2269",
    x: 0,
    y: 220,
    width: 547,
    height: 283,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1102_2269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1102_2269",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapTitleImg);
export default __webpack_public_path__ + "static/media/cap-title-img.562b6aaf.svg";
export { ForwardRef as ReactComponent };